export default require('!css-variables-loader!./main.css');
